import PropTypes from 'prop-types'

const childrenPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.node,
  PropTypes.arrayOf(PropTypes.node)
])

export default childrenPropType
